import script from "./IDMPageV2.vue?vue&type=script&setup=true&lang=js"
export * from "./IDMPageV2.vue?vue&type=script&setup=true&lang=js"

import "./IDMPageV2.vue?vue&type=style&index=0&id=77d1ee37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d1ee37"]])

export default __exports__